
















import { Org, Product } from '@/api';
import { Component, InjectReactive, Prop, Vue } from 'vue-property-decorator';
import { BillingSetupService } from './service/billing-setup-service';
import { WaterProductUtil } from '@/common/WaterProductUtil';
import { WaterEntityUtil } from '@/common/WaterEntityUtil';

@Component({})
export default class BillingPartnerSelection extends Vue {
	@InjectReactive('billingSetupService') service!: BillingSetupService;

	@Prop({ required: true, type: Object })
	public product!: Product;

	public get hasPartners(): boolean {
		return this.availablePartners.length > 0;
	}

	public get availablePartners(): { value: number; text: string }[] {
		if (this.service.productPartnerOrgs === null) {
			return [];
		}
		const isWaterProduct = WaterProductUtil.isWaterProduct(this.product?.type);

		return this.service.productPartnerOrgs.map((org: Org) => {
			let entityAccess = org?.customSettings?.water?.entityAccess;
			let text = org.name!;
			if (isWaterProduct && entityAccess) {
				text += ` (subsidises ${WaterEntityUtil.getEntityTypeDisplayName(entityAccess)} only)`;
			}
			return { value: org.id!, text };
		});
	}

	public updatePartnerId(partnerId: number): void {
		this.service.updatePartnerId(partnerId, this.product.type!);
	}
}
